export enum EmbedPostMessageAction {
    ADD_TO_CART = 'add_to_cart',
    DIALOG_CLOSE = 'dialog_close',
}
